import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { Typography, Box, Modal, Radio, RadioGroup, FormControlLabel, FormControl, TextField, IconButton } from "@mui/material";
import CustomButton from "../../components/buttons/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import errorIcon from "../../../assets/images/ErrorIcon.svg";
import { SelectedAlertsContext } from "../../../utils/SelectedAlertContext";
import { executeActionAPI } from "../../api/api";
import styles from "./popup.module.css";

const getRejectOptions = (alertType) => {
    if (alertType === "RMPM Alert") {
        return [
            "Lag in data",
            "Job works location inventory",
            "Scheduling Issues",
            "QC stock issue",
            "PV issue",
            "Shelf-life master issue",
            "Lead time master issue",
            "STO stock issue"
        ];
    }

    if (alertType === "Agile OR") {
        return [
            "Incorrect Capacity Masters",
            "Incorrect Priority",
            "Lag in production booking"
        ];
    }

    return ["Option 1", "Option 2", "Option 3"];
};

const RejectPopup = ({ open, onClose, onConfirm, alertId, type, updateStatus }) => {

    const options = getRejectOptions(type);

    const { setAlertDetailsData } = useContext(SelectedAlertsContext);

    const [selectedReason, setSelectedReason] = useState("Option 1");
    const [customReason, setCustomReason] = useState("");

    const handleReasonChange = (event) => {
        setSelectedReason(event.target.value);
        if (event.target.value !== "Other") {
            setCustomReason("");
        }
    };

    const handleCustomReasonChange = (event) => {
        setCustomReason(event.target.value);
    };

    const handleReject = async (alertId) => {
        if (onConfirm) onConfirm();
        onClose();

        const rejectionReason = selectedReason === "Other reasons" ? customReason : selectedReason;

        if (type === 'RMPM Alert' || type === 'Agile OR') {
            try {
                await executeActionAPI([alertId["Alert ID"]], "Rejected", rejectionReason, type, [alertId]);

                setAlertDetailsData((prevData) =>
                    prevData.map((item) =>
                        item["Alert ID"] === alertId["Alert ID"]
                            ? { ...item, "Alert status": "Rejected", "Rejection Reason": rejectionReason, "FactoryComments": rejectionReason }
                            : item
                    )
                );

            } catch (error) {
                console.error("Error executing actions:", error);
            }
        } else {
            updateStatus(alertId, rejectionReason);
        }
    };

    const handleCancel = () => {
        onClose();
    };

    const isRejectDisabled = selectedReason === "Other reasons" && customReason.trim() === "";

    return (
        <Modal open={open} onClose={onClose}>
            <div className={styles.modalContainer}>
                <div className={styles.dialogBox}>
                    <div className={styles.dialogBoxContent}>
                        <img src={errorIcon} alt="Error icon" />
                        <div className={styles.rejectContainer}>
                            <Typography className={styles.header}>Reject alert</Typography>
                            <IconButton onClick={onClose}>
                                <CloseIcon className={styles.closeIcon} />
                            </IconButton>
                        </div>
                    </div>

                    <Typography className={styles.subHeader}>
                        Please select the reason for rejection.
                    </Typography>

                    <FormControl component="fieldset">
                        <RadioGroup value={selectedReason} onChange={handleReasonChange}>
                            {options.map((option) => (
                                <FormControlLabel
                                    key={option}
                                    value={option}
                                    control={<Radio className={styles.radioBtn} />}
                                    label={option}
                                    sx={{ ".MuiTypography-root": { fontSize: "12px" } }}
                                />
                            ))}

                            <FormControlLabel
                                value="Other reasons"
                                control={<Radio className={styles.radioBtn} />}
                                sx={{ ".MuiTypography-root": { fontSize: "12px" } }}
                                label={
                                    <Box className={styles.otherReasons}>
                                        Other reasons
                                        {selectedReason === "Other reasons" && (
                                            <TextField
                                                size="small"
                                                value={customReason}
                                                onChange={handleCustomReasonChange}
                                                placeholder="Please specify"
                                                className={styles.textField}
                                                inputProps={{
                                                    style: { fontSize: "12px", padding: "6px 10px" },
                                                }}
                                            />
                                        )}
                                    </Box>
                                }
                            />
                        </RadioGroup>
                    </FormControl>

                    <div className={styles.dialogBtn}>
                        <CustomButton label="Cancel" type="popupCancel" onClick={handleCancel} />
                        <CustomButton label="Reject" type="reject" disabled={isRejectDisabled} onClick={() => handleReject(alertId)} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

RejectPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func,
    open: PropTypes.bool,
    alertId: PropTypes.shape({
        "Alert ID": PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    updateStatus: PropTypes.func,
    type: PropTypes.string,
};

export default RejectPopup;


